export default __webpack_public_path__ + "68025ca067927735a99338148f679406.svg";